import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const StyledDiv = styled.div`
  ${({ theme }) => css`
    padding: 15px 0;
    height: 292px;
    overflow: auto;

    @media screen and (max-width: 430px) {
      height: 80vh;
    }

    .app-icons-inner {
      display: flex;
      flex-wrap: wrap;
      gap: 23px 36px;
      justify-content: center;
      padding-bottom: 14px;
      @media screen and (max-width: 430px) {
        gap: 42px 24px;
      }

      .app-icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 60px;
        height: 60px;
        cursor: pointer;
        font-size: 10px;
        font-weight: 500;
        line-height: 10px;
        background-color: #ffffff;
        border: 1px solid
          ${theme.validateMode({
            light: '#E6E1E5',
            dark: '#938f99',
          })};
        border-radius: 10px;
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.4);
        &:hover {
          background-color: #fffbfe;
        }
        @media screen and (max-width: 430px) {
          width: 103px;
          height: 103px;
        }

        .app-name-default {
          position: absolute;
          color: ${theme.validateMode({
            light: theme.colorsCA.neutral[40],
            dark: theme.colorsCA.neutral[95],
          })};
          top: 64px;
          white-space: nowrap;
          @media screen and (max-width: 430px) {
            top: 106px;
            font-size: 15px;
            line-height: 15px;
            width: 103px;
            white-space: normal;
          }
        }

        img,
        .app-icon-image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          object-fit: contain;
          @media screen and (max-width: 430px) {
            width: 83px;
            height: 83px;
          }
        }
      }
    }
  `}
`;
